import axiosService from "../api/axios";

export const getPublishBannerService = () => {
  return axiosService.get("/banner/publish-banner");
};
